import React from 'react'
import { LatestStoryDiv } from './style'

function LatestStory() {
    return (
        <LatestStoryDiv>
            <div className="inner-container">
            <div className="rowwr">
                <h3 className="">Latest Stories</h3>
                <p className="">Read awesome and healthy blog <br/>
                post from us</p>
            </div>
            </div>
           
            
        </LatestStoryDiv>
    )
}

export default LatestStory
